// src/pages/LandingPageBuilder/index.jsx
import React, { useState } from 'react';
import AppLayout from '../../layouts/AppLayout';
import apiClient from '../../lib/apiClient';
import './styles.css';

const GOALS = [
  { value: 'purchase',      label: 'Compra'             },
  { value: 'lead',          label: 'Captura de lead'    },
  { value: 'whatsapp',      label: 'WhatsApp'           },
  { value: 'instagram',     label: 'Instagram'          },
  { value: 'site_visit',    label: 'Visita ao site'     },
];

export default function LandingPageBuilderPage() {
  const [form, setForm] = useState({
    campaign_id:      '',
    pixel_id:         '',
    conversion_goal:  'purchase',
    headline:         '',
    cta:              'Quero saber mais',
    social_proof:     '',
    destination_url:  '',
  });
  const [result, setResult]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleCreate = async () => {
    if (!form.headline.trim()) { setError('Headline é obrigatório'); return; }
    setError(''); setLoading(true);
    try {
      const r = await apiClient.request('/landing/create', {
        method: 'POST',
        body: JSON.stringify(form),
      });
      const d = await r.json();
      if (d.success) {
        setResult(d.landing_page);
      } else {
        setError(d.message || 'Erro ao criar landing page');
      }
    } catch { setError('Erro de conexão'); }
    finally { setLoading(false); }
  };

  return (
    <AppLayout title="Landing Page Automática" subtitle="Crie uma página de conversão com pixel Meta em segundos" fullWidth>

      {!result ? (
        <div className="lp-builder">
          <div className="lp-section">
            <h3 className="lp-section__title">📌 Configuração</h3>
            <div className="lp-grid">
              <div>
                <label className="lp-label">ID da Campanha (opcional)</label>
                <input className="lp-input" placeholder="Ex: 64abc...123"
                  value={form.campaign_id} onChange={e => set('campaign_id', e.target.value)} />
              </div>
              <div>
                <label className="lp-label">Pixel Meta (Facebook Pixel ID)</label>
                <input className="lp-input" placeholder="Ex: 1234567890"
                  value={form.pixel_id} onChange={e => set('pixel_id', e.target.value)} />
              </div>
            </div>

            <label className="lp-label">Objetivo de conversão</label>
            <div className="lp-goals">
              {GOALS.map(g => (
                <button key={g.value}
                  className={`lp-goal-btn${form.conversion_goal === g.value ? ' lp-goal-btn--active' : ''}`}
                  onClick={() => set('conversion_goal', g.value)}>
                  {g.label}
                </button>
              ))}
            </div>
          </div>

          <div className="lp-section">
            <h3 className="lp-section__title">Conteúdo</h3>

            <label className="lp-label">Headline principal *</label>
            <input className="lp-input" placeholder="Ex: Peça sua pizza e ganhe desconto agora!"
              value={form.headline} onChange={e => set('headline', e.target.value)} />

            <label className="lp-label">Texto do botão (CTA)</label>
            <input className="lp-input" placeholder="Ex: Quero aproveitar!"
              value={form.cta} onChange={e => set('cta', e.target.value)} />

            <label className="lp-label">Prova social</label>
            <textarea className="lp-textarea" rows={3}
              placeholder="Ex: +500 clientes satisfeitos • Avaliação 4.9"
              value={form.social_proof} onChange={e => set('social_proof', e.target.value)} />

            <label className="lp-label">URL de destino</label>
            <input className="lp-input" placeholder="https://wa.me/5511999999999"
              value={form.destination_url} onChange={e => set('destination_url', e.target.value)} />
          </div>

          {error && <div className="lp-error">{error}</div>}

          <button className="lp-btn lp-btn--create" onClick={handleCreate} disabled={loading}>
            {loading ? 'Criando…' : 'Criar Landing Page'}
          </button>
        </div>
      ) : (
        <div className="lp-result">
          <div className="lp-result__success">Landing page criada com sucesso!</div>

          <div className="lp-result__preview">
            <div className="lp-preview-card">
              {result.pixel_installed && (
                <div className="lp-preview-pixel">Pixel Meta instalado: <strong>{result.pixel_id || 'configurado'}</strong></div>
              )}
              <h2 className="lp-preview-headline">{result.headline}</h2>
              {result.social_proof && (
                <p className="lp-preview-proof">{result.social_proof}</p>
              )}
              <a className="lp-preview-cta" href={result.destination_url || '#'} target="_blank" rel="noreferrer">
                {result.cta}
              </a>
              <div className="lp-preview-goal">
                Objetivo: {GOALS.find(g => g.value === result.conversion_goal)?.label}
              </div>
            </div>
          </div>

          <div className="lp-result__info">
            <div className="lp-result__row">
              <span>URL única</span>
              <code className="lp-result__url">/lp/{result.slug}</code>
            </div>
            <div className="lp-result__row">
              <span>Pixel instalado</span>
              <span className={result.pixel_installed ? 'lp-ok' : 'lp-warn'}>
                {result.pixel_installed ? 'Sim' : 'Não configurado'}
              </span>
            </div>
            <div className="lp-result__row">
              <span>Conversões</span><span>0</span>
            </div>
          </div>

          <button className="lp-btn lp-btn--new" onClick={() => { setResult(null); setForm({ campaign_id:'', pixel_id:'', conversion_goal:'purchase', headline:'', cta:'Quero saber mais', social_proof:'', destination_url:'' }); }}>
            + Criar outra
          </button>
        </div>
      )}
    </AppLayout>
  );
}
